import type { NotifierOptions } from '@R/types/toastTypes'

export const defaults: NotifierOptions = {
  toast: {
    location: 'top right',
    timeout: 5000,
    max: 5,
    width: 400,
    sequentialClosing: false,
    closeButton: {
      icon: '$close',
      size: 'small',
      variant: 'text',
    },
  }
}